import {Routes} from '@angular/router';
import {HomeComponent} from '../components/home/home.component';
import {ShowSessionComponent} from '../components/session/show/show-session.component';
import {SessionsComponent} from '../components/session/sessions/sessions.component';
import {blank} from '../../common/strings';
import {loveProfileRoutes} from './love-profile.routes';
import {subscriptionRoutes} from './subscription.routes';
import {
  SpeeddatingFor30YearsOldComponent
} from '../components/how-it-works/speeddating-for-30-years-old/speeddating-for-30-years-old.component';

const contactComponent = () => import('../components/contact/contact.component').then(m => m.ContactComponent)
const aboutUsComponent = () => import('../components/about-us/about-us.component').then(m => m.AboutUsComponent)
const howItWorksComponent = () => import('../components/how-it-works/how-it-works.component').then(m => m.HowItWorksComponent)
const sessionAnimationComponent = () => import('../components/session/animation/session-animation.component').then(m => m.SessionAnimationComponent)
const speeddatingFor30YearsOldComponent = () => import('../components/how-it-works/speeddating-for-30-years-old/speeddating-for-30-years-old.component').then(m => m.SpeeddatingFor30YearsOldComponent)
const speeddatingFor40YearsOldComponent = () => import('../components/how-it-works/speeddating-for-40-years-old/speeddating-for-40-years-old.component').then(m => m.SpeeddatingFor40YearsOldComponent)
const speeddatingFor50YearsOldComponent = () => import('../components/how-it-works/speeddating-for-50-years-old/speeddating-for-50-years-old.component').then(m => m.SpeeddatingFor50YearsOldComponent)

export const routes: Routes = [
  { path: 'home', redirectTo: blank, pathMatch: 'full' },

  ...loveProfileRoutes,
  ...subscriptionRoutes,

  { path: blank, component: HomeComponent,
    data: {
      seo: {
        title: "Speed dating célibataires Nantes : rencontre amoureuse sérieuse entre célibataires à Nantes",
        description: "Speed dating à Nantes : 7 minutes pour faire de vraies rencontres.",
        url: "home"
      }
    }
  },
  { path: 'show/:sessionId', component: ShowSessionComponent },
  {
    path: 'events', component: SessionsComponent,
    data: {
      seo: {
        title: "Évènement célibataires Nantes : profitez d'une soirée speed dating pour célibataires à Nantes",
        description: "Évènement célibataires Nantes : profitez d'une soirée speed dating pour célibataires à Nantes",
        url: "events"
      }
    }
  },
  { path: 'about-us', loadComponent: aboutUsComponent,
    data: {
      seo:  {
        title: "Agence de rencontre Nantes : vivez vos speed dating dans un bar de rencontres pour célibataires à Nantes",
        description: "Agence de rencontre Nantes : vivez vos speed dating dans un bar de rencontres pour célibataires à Nantes",
        url: "about-us"}
    }
  },
  { path: 'how-it-works', loadComponent: howItWorksComponent,
    data: {
      seo: {
        title: "Rencontrer des femmes et des hommes célibataires à Nantes : comment et où encontrer des célibataires nantais ?",
        description: "Rencontrer des femmes et des hommes célibataires à Nantes : comment et où encontrer des célibataires nantais ?",
        url: "how-it-works"
      }
    }
  },
  { path: 'speeddating-for-30-years-old', loadComponent: speeddatingFor30YearsOldComponent,
    data: {
      seo: {
        title: "Speed Dating après 30 ans Nantes : et si tu changeais tes habitudes",
        description: "Speed Dating après 30 ans Nantes : et si tu changeais tes habitudes",
        url: "speeddating-for-30-years-old"
      }
    }
  },
  { path: 'speeddating-for-40-years-old', loadComponent: speeddatingFor40YearsOldComponent,
    data: {
      seo: {
        title: "Speed Dating 40 ans Nantes : des rencontres entre célibataires quadragénaires",
        description: "Speed Dating 40 ans Nantes : des rencontres entre célibataires quadragénaires",
        url: "speeddating-for-40-years-old"
      }
    }
  },
  { path: 'speeddating-for-50-years-old', loadComponent: speeddatingFor50YearsOldComponent,
    data: {
      seo: {
        title: "Speed Dating 50 ans Nantes : retrouve le plaisir de faire des rencontres après 50 ans",
        description: "Speed Dating 50 ans Nantes : retrouve le plaisir de faire des rencontres après 50 ans",
        url: "speeddating-for-50-years-old"
      }
    }
  },
  { path: 'contact', loadComponent : contactComponent,
    data: {
      seo:  {
        title: "7 minutes pour toi | Nous contacter",
        description: "Nous contacter.",
        url: "contact"
      }
    }
  },
  { path: 'terms-and-conditions', loadChildren: () => import('./terms-and-policies.routes').then(m => m.termsAndPoliciesRoutes),
    data: {
      seo:  {
        title: "7 minutes pour toi | Conditions générales",
        description: "Conditions générales",
        url: "terms-and-conditions"}
    }
  },
  { path: 'session-animation/:cityName/:animationCityId',
    loadComponent: sessionAnimationComponent,
    loadChildren: () => import('./animation.routes').then(m => m.animationRoutes),
    data: {
      seo:  {
        title: "7 minutes pour toi | Ma soirée",
        description: "Ma soirée",
        url: "session-animation"}
    }
  },
  { path: '**', component: HomeComponent }
];
